import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../../authentication.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  httpUrl = this.auth.httpUrl;

  constructor(private http: HttpClient, private auth: AuthenticationService) { }

  async insertEmployeeMasterData(obj: any) {
    return await this.http.post(`${this.httpUrl}/hr/employee/insertEmployeeMasterData`, obj).toPromise();
  }

  async updatePersonalInfo(obj: any) {
    return await this.http.post(`${this.httpUrl}/hr/employee/updatePersonalInfo`, obj).toPromise();
  }

  async getPersonalInfo(obj: any) {
    return await this.http.post(`${this.httpUrl}/hr/employee/getPersonalInfo`, obj).toPromise();
  }

  async getEmployeeMasterData(obj: any) {
    return await this.http.get<any>(`${this.httpUrl}/hr/emp_info/empInfo/getAllEmployee${JSON.stringify(obj)}`).toPromise();
  }

  async getArrayAllCurrentEstablishementInfo(obj: any) {
    return await this.http.get<any>(`${this.httpUrl}/hr/establishment/getArrayAllCurrentEstablishementInfo${obj}`).toPromise();
  }
}
